import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export const BrowserFrame = ({ url = "yourbusiness.com", className, children, testId }) => (
  <div
    data-testid={testId}
    className={cn(
      "overflow-hidden rounded-xl border border-white/10 bg-[#0E1015] shadow-[0_50px_120px_-40px_rgba(37,99,235,0.5)]",
      className,
    )}
  >
    <div className="flex items-center gap-3 border-b border-white/[0.08] bg-white/[0.025] px-3 py-2.5 sm:px-4 sm:py-3">
      <div className="flex gap-1.5" aria-hidden="true">
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
      </div>
      <div className="mx-auto flex min-w-0 items-center gap-1.5 rounded-md border border-white/[0.06] bg-black/30 px-3 py-1 font-mono text-xs text-[#A1A1AA]">
        <Lock className="h-3 w-3 shrink-0" aria-hidden="true" />
        <span className="truncate">{url}</span>
      </div>
      <div className="w-10" aria-hidden="true" />
    </div>
    {children}
  </div>
);
